import AccountStatementPage from "./account-statement-page";

export default AccountStatementPage